import App from '@/App.vue'
import config from '@/config'
import is from '@/functions/is'
import router from '@/router'
import store from '@/store'
import Vue from 'vue'

// This works because of `babel-plugin-component`:
// https://github.com/ElementUI/babel-plugin-component
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  FormItem,
  Input,
  Loading,
  Notification,
  Option,
  Rate,
  Row,
  Select,
  Step,
  Steps,
  TimePicker,
  Upload
} from 'element-ui'

import '@/main.scss'

Vue.config.productionTip = false

Vue.prototype.$config = config
Vue.prototype.$is = is
Vue.prototype.$notify = Notification

Vue.use(Alert)
Vue.use(Button)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Option)
Vue.use(Rate)
Vue.use(Row)
Vue.use(Select)
Vue.use(Step)
Vue.use(Steps)
Vue.use(TimePicker)
Vue.use(Upload)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
